// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProductByPath } from "@hardwoods/App/Services/CustomProductServiceV2";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteLoadProduct,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";

export const XngPopulateApiParameter: any = (props: any) => {
    props.apiParameter.getLastPurchase = true;
    props.apiParameter.getProductAdditionalInfo = true;
};

export const XngRequestDataFromApi: any = async (props: any) => {
    props.apiResult = await getProductByPath(props.apiParameter);
};

export const XngDispatchCompleteLoadProduct: any = (props: any) => {
    props.dispatch({
        type: "Data/CustomProductDetails/ProductAdditionalInfo",
        productAdditionalInfo: props.apiResult.properties,
    });
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
addToChainAfter(chain, DispatchCompleteLoadProduct, XngDispatchCompleteLoadProduct);
